<template>
	<li>
		<router-link :to="'/blogs/' + blog.id">
			<div class="blog-list-img">
				<img :src="STATIC_URL + blog.thumb" class="img-responsive" alt="">
			</div>
		</router-link>
		<div class="blog-list-info">
			<h5><router-link :to="'/blogs/' + blog.id">{{ blog.subject }}</router-link></h5>
			<div class="blog-post-meta">
				<span class="updated">{{ blog.postDate | dateFormat('from', $i18n.locale) }}</span> | <router-link :to="'/blogs?cat=' + blog.category">{{ category }}</router-link>
			</div>
		</div>
	</li>
</template>
<script>
export default {
  name: 'BlogBox',
  props: ['blog'],
  computed: {
    category: function() {
      let that = this,
      	  cat = ''
      this.blogCategory.forEach(function(v) {
        if(v.id == that.blog.category) {
          cat = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
        }
      })
      return cat
	}
  },
  created: function() {
    //console.log(this.blog)
  }
}
</script>